/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";

const Header = ({
  label,
  enableBack,
  handleBack,
  handleClose,
  selectionType,
}) => {
  if (selectionType === "judge") {
    enableBack = true;
    label = "judge";
  }

  return (
    <div className="panel__header-container">
      <div className="panel__header-title">
        <span>{label}</span>
      </div>
      <div className="panel__icons-container">
        <div className="panel__header-icon-container">
          {enableBack && (
            <div className="panel__header-icon-container">
              <div
                role="button"
                tabIndex={0}
                onClick={handleBack}
                className="panel__header-button"
              >
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  className="panel__header-icon"
                />
                <span className="panel__back-text">County</span>
              </div>
            </div>
          )}
        </div>
        <div className="panel__header-icon-container">
          <FontAwesomeIcon
            className="panel__header-button panel__header-icon"
            icon={faTimesCircle}
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

Header.defaultProps = {
  label: "county",
  enableBack: false,
  selectionType: "county",
};

Header.propTypes = {
  handleClose: PropTypes.func.isRequired,
  label: PropTypes.string,
  enableBack: PropTypes.bool,
  selectionType: PropTypes.string,
  handleBack: PropTypes.func.isRequired,
};

export default Header;

//
